module.exports = __webpack_public_path__ + "public/images/slider/speaker-10-icon.cdff9507de1bfe61b016279a1468b036.jpg";